import bookings from "src/features/bookings/locales/pl";
import employeesChargingBookings from "src/features/employees-charging-bookings/locales/pl";
import employeesChargingPermissionAccess from "src/features/employees-charging-permission-access/locales/pl";
import employeesChargingPermissionRequests from "src/features/employees-charging-permission-requests/locales/pl";
import employeesChargingPermissions from "src/features/employees-charging-permissions/locales/pl";
import evChargers from "src/features/ev-chargers/locales/pl";
import siteEvChargersElectricityUsage from "src/features/site-ev-chargers-electricity-usage/locales/pl";
import siteEvChargersRules from "src/features/site-ev-chargers-rules/locales/pl";
import siteEvChargersUsageLimits from "src/features/site-ev-chargers-usage-limits/locales/pl";
import siteEvChargers from "src/features/site-ev-chargers/locales/pl";
import siteEvChargingSpots from "src/features/site-ev-charging-spots/locales/pl";
import tenantEvChargersElectricityUsage from "src/features/tenant-ev-chargers-electricity-usage/locales/pl";
import tenantEvChargingSpots from "src/features/tenant-ev-charging-spots/locales/pl";
import assignEvChargers from "./assign-ev-chargers.json";
import auth from "./auth.json";
import billing from "./billing.json";
import blacklist from "./blacklist.json";
import changePassword from "./change-password.json";
import common from "./common.json";
import contactDetails from "./contact-details.json";
import contactForm from "./contact-form.json";
import createPermanentSession from "./create-permanent-session.json";
import createReservation from "./create-reservation.json";
import createRuleGroup from "./create-rule-group.json";
import diagram from "./diagram.json";
import employee from "./employee.json";
import employeesGroupDetails from "./employees-group-details.json";
import employeesGroups from "./employees-groups.json";
import employees from "./employees.json";
import invitations from "./invitations.json";
import issueDetails from "./issue-details.json";
import issues from "./issues.json";
import onboarding from "./onboarding.json";
import organizationAdmins from "./organization-admins.json";
import organizationDetails from "./organization-details.json";
import reservation from "./reservation.json";
import reservations from "./reservations.json";
import resourceGroupDetails from "./resource-group-details.json";
import resources from "./resources.json";
import routes from "./routes.json";
import ruleGroups from "./rule-groups.json";
import settings from "./settings.json";
import siteManagement from "./site-management.json";
import sites from "./sites.json";
import statistics from "./statistics.json";
import supabase from "./supabase.json";
import tenantDetails from "./tenant-details.json";
import tenants from "./tenants.json";
import validation from "./validation.json";
import reservationsSecurity from "./reservations-security.json";
import ruleGroupDetails from "./rule-group-details.json";
import permanentRuleGroups from "./permanent-rule-groups.json";
import createPermanentRuleGroup from "./create-permanent-rule-group.json";
import permanentRuleGroupDetails from "./permanent-rule-group-details.json";
import notifications from "src/features/notifications/shared/locales/pl";
import systemMessages from "src/features/system-messages/shared/locales/pl";
import masterSystemMessages from "src/features/system-messages/master/locales/pl";

export default {
  common,
  reservations,
  reservation,
  createReservation,
  statistics,
  blacklist,
  contactDetails,
  contactForm,
  createPermanentSession,
  createRuleGroup,
  diagram,
  employee,
  employees,
  employeesGroupDetails,
  employeesGroups,
  invitations,
  issues,
  issueDetails,
  organizationDetails,
  resourceGroupDetails,
  resources,
  ruleGroups,
  sites,
  validation,
  settings,
  changePassword,
  onboarding,
  tenants,
  tenantDetails,
  siteManagement,
  organizationAdmins,
  routes,
  billing,
  auth,
  evChargers,
  assignEvChargers,
  tenantEvChargingSpots,
  employeesChargingPermissions,
  employeesChargingPermissionAccess,
  employeesChargingPermissionRequests,
  siteEvChargingSpots,
  siteEvChargersUsageLimits,
  siteEvChargersElectricityUsage,
  siteEvChargersRules,
  siteEvChargers,
  bookings,
  employeesChargingBookings,
  supabase,
  tenantEvChargersElectricityUsage,
  reservationsSecurity,
  ruleGroupDetails,
  permanentRuleGroups,
  createPermanentRuleGroup,
  permanentRuleGroupDetails,
  notifications,
  systemMessages,
  masterSystemMessages,
};
